import {
  Alert,
  // Button,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import NewOrderModal from "../components/NewOrderModal";
import Order from "../components/Order";
import {
  collection,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase-config";
import { UserContext } from "../contexts/userContext";
// import { convertCurrencyFormat } from "../helpers";
// EndShiftConfirmation removed — shift management handled elsewhere
import { getFormattedDate } from "../utils/utils";
import { IOrder, ISale } from "../interfaces";
import { BUSINESS_COLLECTION, SALES_COLLECTION } from "../utils/constants";

const Home = () => {
  const { businessData } = useContext(UserContext);
  // const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [completedOrders, setCompletedOrders] = useState([] as IOrder[]);
  const [otherOrders, setOtherOrders] = useState([] as IOrder[]);
  const [cancelledOrders, setCancelledOrders] = useState([] as IOrder[]);
  const [editableSale, setEditableSale] = useState<ISale | null>(null);

  // const handleClose = () => {
  //   setOpen(false);
  // };

  useEffect(() => {
    if (!businessData.uid) return;
    setLoading(true);
    const salesCollectionRef = collection(
      db,
      BUSINESS_COLLECTION,
      businessData.uid,
      SALES_COLLECTION
    );

    // compute local start = today 16:00, end = tomorrow 05:00
    const now = new Date();
    const start = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      16,
      0,
      0
    );
    const end = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1,
      5,
      0,
      0
    );

    const q = query(
      salesCollectionRef,
      where("createdAt", ">=", start),
      where("createdAt", "<=", end),
      orderBy("createdAt", "desc")
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const allOrders = snapshot.docs.map(
          (doc) =>
            ({
              ...doc.data(),
              id: doc.id,
              createdAt: getFormattedDate(doc.data().createdAt),
              updatedAt: getFormattedDate(doc.data().updatedAt),
            } as IOrder)
        );
        setCompletedOrders(
          allOrders.filter((order) => order.status === "completed")
        );
        setCancelledOrders(
          allOrders.filter((order) => order.status == "cancelled")
        );
        setOtherOrders(
          allOrders.filter(
            (order) =>
              order.status !== "completed" && order.status !== "cancelled"
          )
        );
        setLoading(false);
      },
      (error) => {
        console.error("Error al obtener pedidos en tiempo real: ", error);
        setLoading(false); // También desactivar el loading si hay un error
      }
    );

    return () => unsubscribe();
  }, [businessData.uid]);

  return (
    <Grid container width="100%" display="flex" spacing={2} mt={10}>
      <Grid container size={{ xs: 12, md: 7 }} spacing={2}>
        <NewOrderModal editableSale={editableSale} />
        {/* {shiftInfo?.id && (
          <Grid
            display="flex"
            justifyContent="space-evenly"
            size={{ xs: 12, md: 4 }}
          >
            <Typography>
              Ordenes completadas: {shiftInfo?.totalOrders || 0}
            </Typography>
            <Typography>
              Monto total: {convertCurrencyFormat(shiftInfo?.totalAmount || 0)}
            </Typography>
          </Grid>
        )}
        <Grid display="flex" size={{ xs: 12, md: 4 }}>
          {shiftInfo?.id ? (
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => setOpen(true)}
            >
              Hacer pedido
            </Button>
          ) : (
            <Button
              variant="contained"
              color="info"
              fullWidth
              onClick={() => updateShift("open")}
            >
              Iniciar turno
            </Button>
          )}
        </Grid>
        <Grid display="flex" justifyContent="center" size={{ xs: 12, md: 4 }}>
          {shiftInfo?.id && (
            <Button
              variant="text"
              color="info"
              onClick={() => setOpenConfirmation(true)}
            >
              Cerrar turno
            </Button>
          )}
        </Grid> */}
      </Grid>
      {loading ? (
        <Grid
          size={{ xs: 12, md: 3 }}
          style={{ display: "flex", justifyContent: "center" }}
          mt={5}
        >
          <CircularProgress size={120} />
        </Grid>
      ) : (
        <Grid
          container
          size={{ xs: 12, md: 5 }}
          p={{ xs: 2, md: 0 }}
          spacing={2}
        >
          {/* Órdenes NO completadas */}
          <Grid size={12} mb={3}>
            <Typography variant="h6" color="primary" mb={1}>
              Órdenes en proceso
            </Typography>
            {otherOrders.length > 0 ? (
              <Grid container spacing={1}>
                {otherOrders.map((order) => (
                  <Grid size={{ xs: 12, md: 6 }} key={order.id}>
                    <Order order={order} setEditableSale={setEditableSale} />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Alert severity="warning">No hay órdenes en proceso.</Alert>
            )}
          </Grid>
          {/* Órdenes COMPLETADAS */}
          <Grid size={12} mt={4}>
            <Typography variant="h6" color="success.main" mb={1}>
              Órdenes completadas
            </Typography>
            {completedOrders.length > 0 ? (
              <Grid container spacing={2}>
                {completedOrders.map((order) => (
                  <Grid size={{ xs: 12, md: 4 }} key={order.id}>
                    <Order order={order} minimized />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Alert severity="info">No hay órdenes completadas.</Alert>
            )}
          </Grid>
          {/* Órdenes CANCELADAS */}
          {cancelledOrders.length > 0 && (
            <Grid size={12} mt={4}>
              <Typography variant="h6" color="error" mb={1}>
                Órdenes canceladas
              </Typography>
              <Grid container spacing={2}>
                {cancelledOrders.map((order) => (
                  <Grid size={{ xs: 12, md: 4 }} key={order.id}>
                    <Order order={order} minimized />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default Home;
